import { uiNotification } from "../../../../../../../services/UINotificationService";
import { useContext } from "../context";
import { useAppointmentNoShowNotificationQuery } from "../../../../../../../api/appointments/useAppointmentNoShowNotificationQuery";

export function useNoShowNotification() {
  const { appointment } = useContext();

  const { data } = useAppointmentNoShowNotificationQuery(
    { appointmentId: appointment.id },
    {
      onError: () => {
        uiNotification.error(
          "Unable to load no-shows notification details. Try again later.",
        );
      },
    },
  );

  return data;
}
